import { BannerTitle } from './models/banner-title.model';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  ModalController,
  ViewWillEnter,
  ViewWillLeave,
  ActionSheetController,
} from '@ionic/angular';
import { SearchService } from './services/search.service';
import {
  SearchResultViewModel,
  SearchViewModel,
} from './shared/models/search-view.model';
import { PanAppState, PlatformEnum, PlatformService } from '@panamax/app-state';
import { Product } from '@shared/models/product.model';
import {
  delay,
  filter,
  finalize,
  map,
  take,
  takeWhile,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { Observable, Subscription, combineLatest, firstValueFrom } from 'rxjs';
import {
  ProductPropertiesEnum,
  SearchRequest,
  SortOptions,
} from '@usf/product-types';
import { ListsService } from '../lists/services/lists.service';
import { UsfProductCardModeEnum } from '../shared/constants/usf-product-card-mode.enum';
import {
  LAST_SEARCH_TERM,
  SEARCH_RECORD_PER_BATCH,
  SMALL_RESULT_COUNT_SPACER_HEIGHT,
} from './shared/constants/search-config';
import { TranslateService } from '@ngx-translate/core';
import { ProductExceptionPopoverComponent } from './components/product-exception-popover/product-exception-popover.component';
import { Location } from '@angular/common';
import { BannerType } from './models/banner-type.enum';
import {
  SEARCH_PAGES_ENUM,
  SEARCH_PAGES_SEARCH_KEYS,
} from '../shared/constants/search-pages.enum';
import { EndecaSearchPagesTypes } from '../shared/constants/endeca-search-pages-types';
import { ListsOverlayService } from '../lists/services/lists-overlay.service';
import { getImageIdFromUrl } from './utils/search-url-images.util';
import { ProductAnalyticsService, SEARCH_TYPE } from '@usf/ngrx-product';
import { SearchModeConfig } from './models/search-mode-config.model';
import { SearchModeConfigUtil } from './utils/search-mode-config.util';
import { OrderItemService } from '../shared/services/order-item.service';
import { PATHS } from '../shared/constants/paths';
import { NavigationHelperService } from '../shared/helpers/navigation.helpers.service';
import { SearchTracingService } from './services/search-tracing.service';
import { ModalService } from '../shared/services/modal/modal.service';
import { UserCustomerInfo } from '../home/models/user-customer-info.model';
import { HomeService } from '../home/services/home.service';
import { Customer } from '@usf/customer-types';
import { HelpModalDesktopComponent } from '../shared/components/help-modal/help-modal-desktop/help-modal-desktop.component';
import { PageTitle } from '../shared/constants/page-titles.enum';
import { ModalWithNavComponent } from '../shared/components/modal-with-nav/modal-with-nav.component';
import { HelpModalTouchComponent } from '../shared/components/help-modal/help-modal-touch/help-modal-touch.component';
import { environment } from 'src/environments/environment';
import {
  calculateDesktopProductHeightForSearch,
  calculateMobileProductHeightForSearch,
  calculateTabletProductHeightForSearch,
} from './utils/search-card.util';
import { FEATURES } from '@shared/constants/splitio-features';
import { SearchDeliveryToggleService } from '@search/services/search-delivery-toggle.service';
import { InventoryService } from '@inventory/services/inventory.service';
import { PowerReviewService } from '@shared/services/power-review.service';
import { ProductAlternativeTypeEnum } from '@product-detail/models/product-alternative';
import { PowerReviewRollupModel } from '@usf/ngrx-product/lib/models/power-review-product.model';
import { ProductCompareAnalyticsService } from './services/product-compare-analytics.service';
import { ProductCompareEnum } from '@shared/constants/product-compare.enum';
import { UserService } from '@app/user/services';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import {
  TOP_SECTION_BACKGROUND_IMAGES_MAP,
  TOP_SECTION_IMAGE_TITLE_MAP,
  TOP_SECTION_SEARCH_TEXT_LIST,
  TOP_SECTION_TEXT_CONTENT_MAP,
  TOP_SECTION_TEXT_TITLE_MAP,
  TopSectionSearchText,
  TopSectionSingleBannerSearchText,
  TopBannerType,
  TOP_SECTION_MOBILE_TITLE_MAP,
  TOP_SECTION_BRANDS_LIST,
  TOP_SECTION_BACKGROUND_POSITION_MAP,
  SCOOP_SINGLE_BANNER,
} from '@search/shared/models/search-page.model';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { FileHandlerBaseService } from '@shared/services/file-handler/file-handler-base.service';
import { AddToListModalService } from '@shared/services/dual-pane/add-to-list-modal.service';
import { HttpResponse } from '@angular/common/http';
import Timer = NodeJS.Timer;
import { SearchAnalyticsService } from './services/search-analytics.service';
import { CoveoService } from '@shared/services/coveo/coveo.service';
import {
  buildRecommendations,
  CommerceEngine,
  Recommendations,
  Unsubscribe,
} from '@coveo/headless/commerce';
import { ProductFilter } from '@shared/helpers/product-filter.helpers';
import { ProductFilteringEnum } from '@shared/constants/product-filtering.enum';

@Component({
  selector: 'app-search',
  templateUrl: './search.page.html',
  styleUrls: ['./search.page.scss'],
})
export class SearchPage
  implements ViewWillEnter, ViewWillLeave, AfterViewChecked, OnInit, OnDestroy
{
  @ViewChild(SearchResultComponent)
  searchResultComponent: SearchResultComponent;
  readonly bannerType = BannerType;
  searchViewModel: SearchViewModel;
  selectedSortOption: SortOptions;
  mode: UsfProductCardModeEnum = UsfProductCardModeEnum.defaultSearch;
  modeConfig: SearchModeConfig = SearchModeConfigUtil.getDefaultConfig();
  productSelectionMode = '';
  headerText = '';
  isRenderMoreMode = false;
  replacementBaseProduct: SearchResultViewModel;
  selectedProducts: Product[];
  leftTitleOptions: BannerTitle = {
    view: true,
    principalText: 'i18n.search.searchResultsPage.explore',
    secondaryText: 'i18n.search.searchResultsPage.moreOptions',
  };
  originSearchPage: SEARCH_PAGES_ENUM = SEARCH_PAGES_ENUM.search;
  newScoopProducts = SEARCH_PAGES_SEARCH_KEYS.newScoopProducts;

  searchResult$: Subscription;
  queryParam$: Subscription;
  isTouchExperience$: Subscription;
  searchViewModelSelector$: Subscription;
  deepLinkCustomer$: Subscription;
  toggleStateSub$: Subscription;

  isTouchExperience: boolean;
  isLoading = true;
  isRefreshViewPort: boolean;
  isDeliveryTogglePreset: boolean;
  //Add to list modal
  clearSearchSub$: Subscription;
  productCardHeightTouch = 170;
  productCardHeightDesktop = 120;
  isFirstLoad = true;
  bannerSearchTerm = '';
  isTrackingData = false;
  deepLinkCustomer: Customer;

  userCustomer$: Observable<UserCustomerInfo>;
  usfProductCardModeEnum = UsfProductCardModeEnum;
  searchPagesEnum = SEARCH_PAGES_ENUM;

  itemHeights: number[];

  compareButtonFeatureFlag = FEATURES.split_global_product_compare.name;
  showDownloadButton = FEATURES.split_global_download_search.name;

  showDeliveryToggle = false;

  defaultToggleForAvendra = false;
  DELIVERY_FILTER_METHOD_DISPLAY_NAME = 'Delivery Method';

  addToListSelection = 'add_to_list';
  compareProductsSelection = 'compare_products';
  addToInventorySelection = 'add_to_inventory';

  pwrRatingStarsMap: Observable<Map<string, PowerReviewRollupModel>>;
  powerReviewsMap: Map<string, PowerReviewRollupModel>;

  exceptionId: string;
  orderId: string;

  isTopSection = false;
  isTopSectionTextExpanded: boolean;
  topSectionBackgroundImageStyle: string;
  topSectionBackgroundPosition: string;
  topSectionImageTitle: string;
  topSectionTextTitle: string;
  topSectionTextContent: string;

  isTopSectionSingleBanner = false;
  topSectionSingleBanners: {
    type: TopBannerType;
    backgroundImage: string;
    bannerText?: string;
    styles?: any;
  }[] = [];
  searchText: string;
  isDownloading = false;
  isGuestUser = false;
  distinctSelectedCustomer$: Subscription;
  productNumber: string;
  customQuantity: number;

  // To avoid infine loop on refreshing tests results for Avendera Use Case (1 or less product returned)
  shouldRefreshSearchResults = true;

  commerceEngineSubscription$: Subscription;
  coveoTopSellers$: Observable<ProductDetailViewModel[]>;
  coveoCommerceEngine: CommerceEngine;
  recommendationsController: Recommendations;
  recommendationsControllerUnsubscribe: Unsubscribe;
  newTopSellersProductNumbers: number[];
  private hasTrackedTopSellersAnalytics = false;

  constructor(
    private route: ActivatedRoute,
    readonly platformService: PlatformService,
    protected modalController: ModalController,
    private searchService: SearchService,
    private searchTracingService: SearchTracingService,
    private listsService: ListsService,
    private listsOverlayService: ListsOverlayService,
    private translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    protected router: Router,
    private location: Location,
    private orderItemService: OrderItemService,
    private navigationHelperService: NavigationHelperService,
    private modalService: ModalService,
    private homeService: HomeService,
    private powerReviewService: PowerReviewService,
    readonly panAppState: PanAppState,
    protected searchDeliveryToggleService: SearchDeliveryToggleService,
    private inventoryService: InventoryService,
    private compareAnalytics: ProductCompareAnalyticsService,
    private userService: UserService,
    private fileHandlerBaseService: FileHandlerBaseService,
    private actionSheetController: ActionSheetController,
    private productAnalyticsService: ProductAnalyticsService,
    readonly addToListModalService: AddToListModalService,
    private searchAnalyticsService: SearchAnalyticsService,
    private coveoService: CoveoService,
  ) {}

  ngOnInit(): void {
    this.distinctSelectedCustomer$ = this.panAppState
      .getDistinctSelectedCustomer()
      .pipe(filter(customer => customer?.selected))
      .subscribe(selectedCustomer => {
        this.searchViewModel = {} as SearchViewModel;
      });
  }
  ngAfterViewChecked(): void {
    this.searchTracingService.emitSearchResultsRendered(
      this.searchViewModel?.searchResponse?.pagination?.offset,
    );
  }

  ionViewWillEnter(): void {
    this.queryParam$ = combineLatest([
      this.userService.isGuestUser$(),
      this.panAppState.feature$([FEATURES.split_global_delivery_toggle.name]),
      this.panAppState.feature$([
        FEATURES.split_customization_delivery_toggle_preset.name,
      ]),
      this.route.queryParams,
    ]).subscribe(([isGuest, deliveryToggle, deliveryTogglePreset, params]) => {
      this.isGuestUser = isGuest;

      if (deliveryToggle) {
        this.showDeliveryToggle = true;
      }

      this.isDeliveryTogglePreset = deliveryTogglePreset;

      this.setPageTitle(params);
      this.updatePageMode(params);
      this.updateProductSelectionMode(params);
      this.getSearchResult(params);
      this.updateOriginSearchPage(params);
      this.updateTopSection(params);
      this.searchTracingService.resetSearchPageTracing();
      this.exceptionId = params.exceptionId;
      this.orderId = params.orderId;
      this.searchText = params?.searchText;
      this.productNumber = params?.productNumber;
      this.customQuantity = params?.customQuantity;
      this.updateTopSectionSingleBanner();
    });

    // Memory Leak
    this.toggleStateSub$ = this.searchDeliveryToggleService.toggleState
      .pipe(delay(1000))
      .subscribe(toggleIsOn => {
        this.searchDeliveryToggleService.toggleIsOn = toggleIsOn;
        const currentUrl = window.location.search;
        const urlParams = new URLSearchParams(currentUrl);
        let searchFilterProperties =
          urlParams.get('searchFilterProperties') ?? '';
        let request;
        searchFilterProperties = searchFilterProperties
          .replace(environment.searchDeliveryFilterUsFoodsDelivered, '')
          .replace(/\s\s+/g, ' '); // clear white spaces

        if (this.searchDeliveryToggleService.toggleIsOn) {
          if (searchFilterProperties !== '') {
            searchFilterProperties = searchFilterProperties.concat(' ');
          }
          searchFilterProperties = searchFilterProperties.concat(
            environment.searchDeliveryFilterUsFoodsDelivered,
          );
        }
        if (this.searchDeliveryToggleService.toggleIsOn) {
          this.searchService.trackTogglingUsFoodsDeliveredProductsOn();
        } else {
          this.searchService.trackTogglingUsFoodsDeliveredProductsOff();
        }
        request = {
          ...this.searchViewModel.searchRequest,
          searchFilterProperties,
        };
        console.log(
          '[Compare] Will Refresh for toggle, base product: ' +
            this.replacementBaseProduct?.productNumber,
        );
        this.refreshSearchResult(request);
      });

    this.isTouchExperience$ = this.platformService.isTouchExperience$.subscribe(
      isTouchExperience => {
        this.isTouchExperience = isTouchExperience;
      },
    );

    this.userCustomer$ = this.homeService.loadUserCustomer$();

    this.commerceEngineSubscription$ = this.coveoService
      .getCommerceEngine$()
      .pipe(filter(engine => !!engine))
      .subscribe(engine => {
        this.coveoCommerceEngine = engine;
        this.recommendationsController = buildRecommendations(
          this.coveoCommerceEngine,
          {
            options: {
              slotId: `${environment.coveoRecommendationsSlots.topSellersNoSearchResults}`,
            },
          },
        );
        this.recommendationsControllerUnsubscribe =
          this.recommendationsController.subscribe(() => {
            this.newTopSellersProductNumbers =
              this.recommendationsController?.state['products']?.map(product =>
                Number(product.ec_product_id),
              );
            this.coveoTopSellers$ = this.searchService
              .getCoveoTopSellersProducts(this.newTopSellersProductNumbers)
              .pipe(
                filter(products => products.length > 0),
                map(products => products.slice(0, 12)),
                tap(products => {
                  if (!this.hasTrackedTopSellersAnalytics) {
                    this.searchService.trackTopSellersNullResults(products);
                    this.hasTrackedTopSellersAnalytics = true;
                  }
                }),
              );
          });
      });
  }

  setPageTitle(params: Params) {
    let searchParam = params?.searchText;
    if (!!params?.brandName) {
      searchParam = decodeURIComponent(params.brandName).toLowerCase();
    }

    if (
      (!!params?.brandName && TOP_SECTION_BRANDS_LIST.includes(searchParam)) ||
      TOP_SECTION_SEARCH_TEXT_LIST.includes(searchParam)
    ) {
      this.panAppState.setPageTitle(
        this.translateService.instant(
          TOP_SECTION_MOBILE_TITLE_MAP.get(searchParam),
        ),
      );
    } else {
      this.panAppState.setPageTitle(
        this.translateService.instant(PageTitle.shopProducts),
      );
    }
  }

  ionViewDidEnter() {
    // Rebind data if subscription is lost
    // usually happens when the user visits a pdp and goes back
    if (this.searchResult$?.closed) {
      this.searchResult$ = this.searchService
        .searchResultsSelector$(this.searchViewModel)
        .subscribe(vm => {
          this.searchViewModel = { ...vm };
          this.cdRef.detectChanges();
          this.calculateItemHeights();
        });
    }
  }

  ionViewWillLeave(): void {
    this.isTouchExperience$?.unsubscribe();
    this.searchResult$?.unsubscribe();
    this.queryParam$?.unsubscribe();
    this.searchViewModelSelector$?.unsubscribe();
    this.deepLinkCustomer$?.unsubscribe();
    this.clearSearchSub$?.unsubscribe();

    this.modalController.getTop().then(modal => modal?.dismiss());
    this.toggleStateSub$.unsubscribe();
  }

  ngOnDestroy(): void {
    this.distinctSelectedCustomer$?.unsubscribe();
  }
  updatePageMode(params: Params): void {
    const productNumber = +params.productNumber;
    const mode = params.mode;
    if (productNumber > 0) {
      console.log('[Compare] Setting base product from url' + productNumber);
      this.setPageMode(UsfProductCardModeEnum[mode], false);
      this.setBaseProduct(productNumber);
    } else {
      this.setPageMode(
        mode
          ? UsfProductCardModeEnum[mode]
          : UsfProductCardModeEnum.defaultSearch,
        false,
      );
      this.replacementBaseProduct = null;
    }
  }

  setPageMode(mode: UsfProductCardModeEnum, navigation: boolean = true) {
    this.mode = mode;
    this.modeConfig = SearchModeConfigUtil.getSearchModeConfig(mode);

    if (navigation) {
      const currentPath = window.location.pathname;
      let paramObj = {};
      this.navigationHelperService.getQueryParams().forEach((value, key) => {
        paramObj[key] = value;
      });

      const queryParams = {
        ...paramObj,
        mode: mode,
        productSelectionMode: null,
      };

      this.router.navigate(['.'], {
        queryParams,
        replaceUrl: true,
        relativeTo: this.route,
        queryParamsHandling: 'merge',
      });
    }
  }

  updateProductSelectionMode(params: Params) {
    const selectionMode = params.productSelectionMode;
    console.log(
      '[Compare] setting selection mode from params to ' + selectionMode,
    );
    this.productSelectionMode = selectionMode;
    if (
      this.mode === UsfProductCardModeEnum.addToListSearch &&
      !selectionMode
    ) {
      console.log('[Compare] Updating to add to list selection mode');
      this.productSelectionMode = this.addToListSelection;
    }
    if (
      this.mode === UsfProductCardModeEnum.addToInventorySearch &&
      !selectionMode
    ) {
      this.productSelectionMode = this.addToInventorySelection;
    }
  }

  setProductSelectionMode(productSelectionMode: string) {
    this.productSelectionMode = productSelectionMode;
    const currentPath = window.location.pathname;
    let paramObj = {};
    this.navigationHelperService.getQueryParams().forEach((value, key) => {
      paramObj[key] = value;
    });

    const queryParams = {
      ...paramObj,
      productSelectionMode: productSelectionMode,
    };

    this.router.navigate(['.'], {
      queryParams,
      replaceUrl: true,
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    });
  }

  updateOriginSearchPage(params: Params): void {
    const originSearchPageParam = params.originSearchPage;
    this.originSearchPage = originSearchPageParam
      ? SEARCH_PAGES_ENUM[originSearchPageParam]
      : SEARCH_PAGES_ENUM.search;
  }

  getSearchResult(params: Params): void {
    this.isLoading = true;
    this.isRefreshViewPort = true;
    this.isRenderMoreMode = false;
    this.isTrackingData = false;
    // Reset analytics tracking flags for new search
    this.hasTrackedTopSellersAnalytics = false;
    // Reset page state
    this.clearSelectedProducts();
    // Build searchRequest from params
    let searchParams = { ...params };
    delete searchParams.mode;
    delete searchParams.productSelectionMode;

    const originalRequest = this.searchService.getSearchRequest(
      searchParams,
      this.mode,
    );

    this.defaultToggleForAvendra =
      this.isDeliveryTogglePreset && searchParams?.searchToggle?.length !== 0;
    if (this.defaultToggleForAvendra && this.shouldRefreshSearchResults) {
      let searchFilterProperties = searchParams?.searchFilterProperties ?? '';
      if (
        !searchFilterProperties.includes(
          environment.searchDeliveryFilterUsFoodsDelivered,
        )
      ) {
        if (searchFilterProperties !== '') {
          searchFilterProperties = searchFilterProperties.concat(' ');
        }
        searchFilterProperties = searchFilterProperties.concat(
          environment.searchDeliveryFilterUsFoodsDelivered,
        );

        searchParams = {
          ...searchParams,
          searchFilterProperties,
          searchToggle: 'searchToggle',
        };
      }
    }

    const request = this.searchService.getSearchRequest(
      searchParams,
      this.mode,
    );

    const isSameRequest =
      JSON.stringify(request) ===
      JSON.stringify(this.searchViewModel?.searchRequest);
    if (isSameRequest) {
      this.isLoading = false;
      this.searchResultComponent?.getViewport()?.checkViewportSize();
      return;
    }
    // Clear previous searchResult subscriptions and subscribe using new request
    if (!!this.searchViewModel?.listProducts?.length) {
      this.searchViewModel.listProducts = [];
      this.isFirstLoad = true;
      this.cdRef.detectChanges();
    }
    this.searchResult$?.unsubscribe();
    this.searchResultComponent?.getViewport()?.scrollToIndex(0);

    let searchAgainWithoutToggle = false;
    this.searchResult$ = this.searchService
      .getSearchResult(request, [])
      .pipe(
        takeWhile(result => {
          const isDeliveryMethod = result?.searchResponse?.navigation?.some(
            f => f.displayName === this.DELIVERY_FILTER_METHOD_DISPLAY_NAME,
          );
          if (
            this.defaultToggleForAvendra &&
            result?.listProducts?.length === 0 &&
            this.shouldRefreshSearchResults
          ) {
            this.defaultToggleForAvendra = false;
            searchAgainWithoutToggle = true;
            return false;
          } else if (
            this.defaultToggleForAvendra &&
            result?.listProducts?.length === 1 &&
            isDeliveryMethod &&
            this.shouldRefreshSearchResults
          ) {
            this.defaultToggleForAvendra = false;
            searchAgainWithoutToggle = true;
            return false;
          } else {
            return true;
          }
        }),
        finalize(() => {
          if (searchAgainWithoutToggle && this.shouldRefreshSearchResults) {
            originalRequest.searchFilterProperties =
              originalRequest.searchFilterProperties
                ?.replace(environment.searchDeliveryFilterUsFoodsDelivered, '')
                ?.replace(/\s\s+/g, ' ');
            this.searchDeliveryToggleService.toggleIsOn = false;
            this.shouldRefreshSearchResults = false;
            this.getSearchResult({
              ...originalRequest,
              searchToggle: '',
            });
          }
        }),
      )
      .subscribe(result => {
        this.shouldRefreshSearchResults = true;
        this.trackPageLoad(result);
        if (result?.searchResponse?.headerDetails?.headerText?.length > 0) {
          sessionStorage.setItem(
            LAST_SEARCH_TERM,
            result.searchResponse.headerDetails.headerText,
          );
        }
        this.searchTracingService.emitSearchResultsLoaded(
          result.searchResponse?.pagination?.offset,
        );
        if (
          result.searchRequest?.searchFilterProperties &&
          result.searchRequest?.searchFilterProperties ===
            environment.whileSuppliesLast.toString()
        ) {
          this.searchTracingService.traceWhileSuppliesLastSuccess();
        }
        this.searchViewModel = result;
        if (!result.searchResponse?.totalNumberOfRecords) {
          this.recommendationsController?.refresh();
        }
        this.checkToggleIsDisabled(result);
        this.checkToggleIsOn();

        if (this.isLoading) {
          this.pwrRatingStarsMap =
            this.powerReviewService.loadPowerReviewsProduct(
              this.productNumbersConcat(result, 0, SEARCH_RECORD_PER_BATCH),
            );
          this.setPowerReviews();
        }

        this.isLoading = false;
        if (!this.isRenderMoreMode) {
          this.searchViewModel.isLoadingMore = false;
          this.cdRef.detectChanges();
          this.calculateItemHeights();

          if (this.searchViewModel?.searchResponse?.sortOptions?.length > 0) {
            this.selectedSortOption =
              this.searchViewModel?.searchResponse.sortOptions.filter(
                so => so.selected,
              )[0];
          }
          this.updateHeaderText();
          // Carry selection between page loads (TODO TRACK A SINGLE LIST OF ITEMS INSTEAD)
          this.selectedProducts.forEach(selectedProduct => {
            const product = this.searchViewModel.listProducts.find(
              product =>
                product.productNumber === selectedProduct.productNumber,
            );
            if (product) product.selected = true;
          });

          if (this.isRefreshViewPort) {
            setTimeout(() => {
              this.searchResultComponent?.getViewport()?.checkViewportSize();
              this.isFirstLoad = false;
            }, 1000);
          }
        }
      });
  }

  checkToggleIsDisabled(searchViewModel: SearchViewModel) {
    if (this.isUsFoodsDeliveredFilterPresent(searchViewModel)) {
      this.searchDeliveryToggleService.toggleIsDisabled = false;
    } else {
      this.searchDeliveryToggleService.toggleIsDisabled = true;
    }
  }

  isUsFoodsDeliveredFilterPresent(searchViewModel: SearchViewModel): boolean {
    let isDeliveryMethodFilter = false;
    searchViewModel?.searchResponse?.navigation?.forEach(value => {
      if (value.displayName === this.DELIVERY_FILTER_METHOD_DISPLAY_NAME) {
        isDeliveryMethodFilter = value.refinements.some(
          value1 => value1.name === 'US Foods Delivered',
        );
      }
    });
    return isDeliveryMethodFilter;
  }

  checkToggleIsOn() {
    const currentUrl = window.location.search;
    const urlParams = new URLSearchParams(currentUrl);
    let searchToggleFlag = urlParams.get('searchToggle') ?? '';
    if (!!searchToggleFlag || this.defaultToggleForAvendra) {
      this.searchDeliveryToggleService.toggleIsOn = true;
    } else {
      this.searchDeliveryToggleService.toggleIsOn = false;
    }
  }

  checkToggleParam(request: SearchRequest) {
    let searchToggle = '';
    // first  condition check close pill and clear
    if (
      request?.searchFilterProperties?.includes(
        environment.searchDeliveryFilterUsFoodsDelivered,
      )
    ) {
      searchToggle = 'searchToggle';
      this.searchDeliveryToggleService.toggleIsOn = true;
    }

    return { ...request, searchToggle };
  }

  async refreshSearchResult(request: SearchRequest, replaceUrl = false) {
    console.log('[Compare] Refreshing search result');
    request = this.checkToggleParam(request);
    // Navigate to the search page with the new params
    this.searchResultComponent?.getViewport()?.scrollToIndex(0);
    const currentPath = window.location.pathname;
    console.log(
      '[Compare] Will navigate to search with mode ' +
        this.mode +
        'and selection mode ' +
        this.productSelectionMode,
    );
    if (
      request?.searchFilterProperties === null &&
      request?.rangeRefinements === null &&
      request.pageType === EndecaSearchPagesTypes.catalog
    ) {
      request.pageType = EndecaSearchPagesTypes.all;
    }
    await this.router.navigate(
      [currentPath.split('/')[1], EndecaSearchPagesTypes.search],
      {
        queryParams: {
          ...request,
          mode: this.mode,
          productSelectionMode: this.productSelectionMode,
        },
        replaceUrl,
      },
    );
  }

  handleSelectedProducts(selectedProducts: Product[]) {
    //add base to selected product in compare scenario
    let finalSelectedProducts = [];
    if (
      this.productSelectionMode === this.compareProductsSelection &&
      !!this.replacementBaseProduct
    ) {
      finalSelectedProducts.push(this.replacementBaseProduct);
    }
    finalSelectedProducts.push(...selectedProducts);
    this.selectedProducts = finalSelectedProducts;

    if (
      this.mode === UsfProductCardModeEnum.compareProducts ||
      this.productSelectionMode === this.compareProductsSelection
    ) {
      this.disabledCardCheckBoxes(this.selectedProducts.length >= 4);
    }
  }

  disabledCardCheckBoxes(disabled: boolean) {
    this.searchViewModel?.listProducts?.forEach(product => {
      if (!this.selectedProducts.includes(product)) {
        product.disabled = disabled;
      }
    });
  }

  updateHeaderText() {
    if (this.searchViewModel.searchRequest.searchText?.indexOf('+') > 0) {
      this.headerText = this.searchViewModel.searchRequest.searchText.trim();
    } else if (
      this.bannerSearchTerm &&
      this.mode === UsfProductCardModeEnum.bannerSearch
    ) {
      this.headerText = this.bannerSearchTerm;
    } else if (!!this.searchViewModel.searchResponse?.headerDetails) {
      this.headerText =
        this.searchViewModel.searchResponse?.headerDetails?.headerText?.trim() ||
        this.translateService.instant('i18n.search.allProducts');
    } else if (!!this.searchViewModel.searchRequest.searchText) {
      if (
        !!this.searchViewModel.searchRequest?.pageType &&
        this.searchViewModel.searchRequest?.pageType !=
          EndecaSearchPagesTypes.search
      ) {
        this.headerText = `${this.searchViewModel.searchResponse?.headerDetails?.headerText?.trim()} + ${this.searchViewModel.searchRequest.searchText.trim()}`;
      } else {
        this.headerText = this.searchViewModel.searchRequest.searchText.trim();
      }
    } else {
      this.headerText = this.translateService.instant(
        'i18n.search.allProducts',
      );
    }
  }

  handleAddToListClick() {
    this.clearSelectedProducts();
    if (this.productSelectionMode === this.addToListSelection) {
      this.setProductSelectionMode(null);
    } else if (this.mode === UsfProductCardModeEnum.compareProducts) {
      this.cancelAddToListSelection();
    } else {
      this.setProductSelectionMode(this.addToListSelection);
    }
  }

  handleAddToInventoryClick() {
    this.clearSelectedProducts();
    if (this.productSelectionMode === this.addToInventorySelection) {
      this.setProductSelectionMode(null);
    } else {
      this.setProductSelectionMode(this.addToInventorySelection);
    }
  }

  handleCompareProducts() {
    if (
      this.mode === UsfProductCardModeEnum.replacementSearch &&
      this.replacementBaseProduct &&
      this.productSelectionMode !== this.compareProductsSelection
    ) {
      this.compareAnalytics.trackUserStartingProductCompareOnSearchForSubs(
        this.replacementBaseProduct,
      );
    } else {
      this.compareAnalytics.trackUserStartingProductCompare();
    }

    this.clearSelectedProducts();
    if (this.mode === UsfProductCardModeEnum.compareProducts) {
      this.cancelAddToListSelection();
    } else if (this.productSelectionMode === this.compareProductsSelection) {
      this.setProductSelectionMode(null);
    } else if (
      this.replacementBaseProduct ||
      this.mode === UsfProductCardModeEnum.addToListSearch
    ) {
      this.setProductSelectionMode(this.compareProductsSelection);
    } else {
      this.setPageMode(UsfProductCardModeEnum.compareProducts);
    }
  }

  redirectToComparePage() {
    this.compareAnalytics.trackProductCompareSubmit(
      this.selectedProducts,
      this.searchViewModel,
      this.mode,
      this.replacementBaseProduct?.productNumber,
    );
    let compareMode = null;
    if (
      this.mode === UsfProductCardModeEnum.replacementSearch &&
      this.replacementBaseProduct?.summary?.properties?.has(
        ProductPropertiesEnum.discontinued,
      )
    ) {
      compareMode = ProductCompareEnum.replacementCompare;
    } else if (this.mode === UsfProductCardModeEnum.cartReplacementSearch) {
      compareMode = ProductCompareEnum.orderSubCompare;
    } else if (this.mode === UsfProductCardModeEnum.exceptionSearch) {
      compareMode = ProductCompareEnum.exceptionSubCompare;
    }

    this.navigationHelperService.routeTo(PATHS.SEARCH_COMPARE, {
      selectedProducts: this.getProductNumberAsQueryParam(),
      originalItem: this.replacementBaseProduct?.productNumber,
      mode: compareMode,
      exceptionId: this.exceptionId,
      orderId: this.orderId,
    });
  }

  public get UsfProductCardModeEnum(): typeof UsfProductCardModeEnum {
    return UsfProductCardModeEnum;
  }

  cancelAddToListSelection() {
    this.setPageMode(UsfProductCardModeEnum.defaultSearch);
    this.clearSelectedProducts();
  }

  nextBatch(currentElementIndex) {
    const total = this.searchResultComponent?.getViewport().getDataLength();

    if (this.searchViewModel) {
      this.pwrRatingStarsMap =
        this.powerReviewService.loadPowerReviewsProductFromStore();
    }
    const ELEMENTS_BEFORE_PAGES_END = 20;
    if (
      currentElementIndex >= total - ELEMENTS_BEFORE_PAGES_END &&
      this.searchViewModel?.listProducts?.length <
        this.searchViewModel?.searchResponse?.totalNumberOfRecords &&
      !this.searchViewModel.isLoadingMore &&
      !this.isFirstLoad
    ) {
      this.isRenderMoreMode = true;
      this.searchViewModel.isLoadingMore = true;
      this.isRefreshViewPort = false;
      const recordsPerPage = SEARCH_RECORD_PER_BATCH;
      const offset =
        this.searchViewModel?.searchResponse?.pagination?.offset +
        SEARCH_RECORD_PER_BATCH -
        1;

      this.searchResult$?.unsubscribe();
      this.searchResult$ = this.searchService
        .getSearchResult(
          {
            ...this.searchViewModel?.searchRequest,
            offset,
            recordsPerPage,
          },
          this.searchViewModel.listProducts.map(
            product => product.productNumber,
          ),
        )
        .pipe(
          tap(result => {
            this.searchTracingService.emitSearchResultsLoaded(
              result.searchResponse?.pagination?.offset,
            );
            if (!!result?.listProducts.length) {
              if (this.searchViewModel?.isLoadingMore) {
                this.pwrRatingStarsMap =
                  this.powerReviewService.updatePowerReviewsProduct(
                    this.productNumbersConcat(
                      result,
                      offset,
                      SEARCH_RECORD_PER_BATCH,
                    ),
                  );
                this.searchService.trackMoreSearchResultsLoading(
                  this.searchAnalyticsService.buildExceptionTrackingProducts(
                    result.listProducts.slice(offset, offset + recordsPerPage),
                  ),
                );
              }

              this.searchViewModel = {
                ...this.searchViewModel,
                searchResponse: {
                  ...this.searchViewModel.searchResponse,
                  pagination: {
                    offset: result.searchResponse?.pagination?.offset,
                    recsPerPage: result.searchResponse?.pagination?.recsPerPage,
                  },
                },
                listProducts: [
                  ...result.listProducts.map(product => {
                    return {
                      ...product,
                      selected: !!this.searchViewModel.listProducts.find(
                        searchProduct =>
                          searchProduct.productNumber === product.productNumber,
                      )?.selected,
                    };
                  }),
                ],
                isLoadingMore: false,
              };
              this.calculateItemHeights();
              this.pwrRatingStarsMap =
                this.powerReviewService.updatePowerReviewsProduct(
                  this.productNumbersConcat(
                    result,
                    offset,
                    SEARCH_RECORD_PER_BATCH,
                  ),
                );
              this.setPowerReviews();
            }
            this.searchViewModel.isLoadingMore = false;
            this.cdRef.detectChanges();
            this.searchResultComponent?.getViewport()?.checkViewportSize();
          }),
        )
        .subscribe();
    }
  }

  getProductNumberAsQueryParam() {
    return this.selectedProducts.map(value => value.productNumber).join(',');
  }

  async openActionModal() {
    if (this.mode === UsfProductCardModeEnum.replacementSearch) {
      await this.openProductReplacementPopover();
    } else if (this.mode === UsfProductCardModeEnum.exceptionSearch) {
      await this.openProductExceptionPopover();
    } else if (this.mode === UsfProductCardModeEnum.cartReplacementSearch) {
      const productToBeReplaced: Product = this.replacementBaseProduct;
      const selectedReplacementProduct: Product = this.selectedProducts.find(
        product => !!product,
      );
      if (productToBeReplaced && selectedReplacementProduct) {
        this.orderItemService.substituteProducts(
          productToBeReplaced,
          selectedReplacementProduct,
        );
        this.navigationHelperService.routeTo(PATHS.ORDER);
      }
    } else if (
      this.mode === UsfProductCardModeEnum.addToInventorySearch ||
      this.productSelectionMode === this.addToInventorySelection
    ) {
      await this.openAddToInventoryModal();
    } else if (
      this.mode === UsfProductCardModeEnum.addToListSearch ||
      this.productSelectionMode === this.addToListSelection
    ) {
      this.openAddToListModal();
    }
  }

  async openProductReplacementPopover() {
    const replacementProductIsDiscontinued =
      this.replacementBaseProduct?.summary?.properties?.has(
        ProductPropertiesEnum.discontinued,
      );
    if (replacementProductIsDiscontinued) {
      this.openReplaceProductModal();
    } else {
      this.openAddToListModal();
    }
  }

  openAddToListModal = () => {
    this.addToListModalService.openModal(this.selectedProducts, false, false);
    this.clearSearchSub$ = this.addToListModalService.clearSearch.subscribe(
      () => {
        this.clearSelectedProducts();
      },
    );
  };

  closeAndDeatachAddToListModal = () => {
    this.addToListModalService.closeModal();
    this.clearSearchSub$?.unsubscribe();
  };

  async openReplaceProductModal() {
    const listPageData = await firstValueFrom(this.listsService.listsView$());
    const ret = this.listsOverlayService.openReplaceProductModal(
      this.replacementBaseProduct?.productNumber,
      this.selectedProducts[0].productNumber,
      listPageData?.lastSelectedList,
    );
    (await ret).onDidDismiss().then(res => {
      if (res.data?.didSubmit) {
        this.clearSelectedProducts();
      }
    });
  }

  async openProductExceptionPopover() {
    let exceptionId = '';
    this.route.queryParamMap.pipe(take(1)).subscribe(queryParamsMap => {
      exceptionId = queryParamsMap.get('exceptionId');
    });

    this.modalService.setModalOptions(
      this.platformService.isTouch.value,
      ProductExceptionPopoverComponent,
      {
        product: this.replacementBaseProduct,
        replacementProduct: this.selectedProducts[0],
        quantityEach: {
          previousValue: 0,
          currentValue: 0,
          loading: false,
          error: null,
        },
        quantityUnit: {
          previousValue: 0,
          currentValue: 0,
          loading: false,
          error: null,
        },
        exceptionId,
        customQuantity: this.customQuantity,
        // TODO URL / ORIGIN Where should the user be redirect after confirmation?
        // redirectLocation: '/pdp'
        mode: this.mode,
      },
      'modal-desktop-size-lg',
    );

    const modal = await this.modalController.create(
      this.modalService.modalOptions,
    );

    modal.onDidDismiss().then(payload => {
      if (payload.data?.success) {
        this.location.back();
      }
    });
    await modal.present();
  }

  setBaseProduct(productNumber: number): void {
    this.searchService
      .getReplacementBaseProduct(productNumber)
      .pipe(
        filter(baseProduct => !!baseProduct),
        take(1),
      )
      .subscribe(baseProduct => {
        // Alternative is hidden for this view
        const initialSetup = !this.replacementBaseProduct;

        this.replacementBaseProduct = {
          ...baseProduct,
          alternative: {
            ...baseProduct.alternative,
            available: false,
          },
        };
        if (this.productSelectionMode === this.compareProductsSelection) {
          this.replacementBaseProduct.selected = true;
          this.replacementBaseProduct.disabled = true;
          this.selectedProducts = [this.replacementBaseProduct];
        }
        if (
          initialSetup &&
          this.replacementBaseProduct.alternative?.type ===
            ProductAlternativeTypeEnum.replacement &&
          this.productSelectionMode !== this.compareProductsSelection
        ) {
          this.setProductSelectionMode(this.addToListSelection);
        }
      });
  }

  clearSelectedProducts() {
    this.searchViewModel?.listProducts?.forEach(
      product => (product.selected = false),
    );
    this.handleSelectedProducts([]);
  }

  goToTop() {
    this.searchResultComponent?.getViewport()?.scrollToIndex(0);
  }

  bannerSearchMode(searchTerm: string) {
    this.setPageMode(UsfProductCardModeEnum.bannerSearch, false);
    this.bannerSearchTerm = searchTerm;
  }

  public get sectionToGoBack() {
    const modeToGoBack = {
      [UsfProductCardModeEnum.exceptionSearch]: this.translateService.instant(
        'i18n.orderExceptionsPage.resolveExceptions',
      ),
      [UsfProductCardModeEnum.replacementSearch]:
        this.replacementSectionToGoBack(),
      [UsfProductCardModeEnum.addToInventorySearch]:
        this.translateService.instant('i18n.inventory.inventoryTitle'),
    };
    return modeToGoBack[this.mode] || '';
  }

  replacementSectionToGoBack() {
    let section = 'i18n.search.searchResults.title';
    switch (this.originSearchPage) {
      case SEARCH_PAGES_ENUM.listDetail:
        section = 'i18n.lists.listDetails';
        break;
      case SEARCH_PAGES_ENUM.deals:
        section = 'i18n.deals.deals';
        break;
      case SEARCH_PAGES_ENUM.reviewOrder:
        section = 'i18n.lists.reviewOrder';
        break;
      case SEARCH_PAGES_ENUM.pdp:
        section = 'i18n.productDetail.title';
        break;
      case SEARCH_PAGES_ENUM.topSellers:
        section = 'i18n.pageTitles.topSellers';
        break;
      case SEARCH_PAGES_ENUM.trendingNow:
        section = 'i18n.pageTitles.trendingNow';
        break;
      case SEARCH_PAGES_ENUM.didYouForget:
        section = 'i18n.pageTitles.didYouForget';
        break;
    }
    return this.translateService.instant(section);
  }

  async goBack() {
    if (this.mode === UsfProductCardModeEnum.addToInventorySearch) {
      this.inventoryService.goToWorksheet(
        this.inventoryService.exposedLastInventory,
      );
    } else {
      if (this.originSearchPage === SEARCH_PAGES_ENUM.listDetail) {
        const listPageData = await firstValueFrom(
          this.listsService.listsView$(),
        );
        if (!!listPageData?.lastSelectedList) {
          this.navigationHelperService.routeTo(
            `lists/detail/${listPageData?.lastSelectedList?.listKey?.listTypeId}-${listPageData?.lastSelectedList?.listKey?.listId}`,
          );
        } else {
          this.navigationHelperService.redirectionBack();
        }
      } else if (this.originSearchPage === SEARCH_PAGES_ENUM.pdp) {
        this.navigationHelperService.routeTo(`products/${this.productNumber}`);
      } else {
        this.navigationHelperService.redirectionBack();
      }
    }
  }

  async openHelpModal() {
    if (this.platformService.isTouch.value) {
      this.modalService.setModalOptions(true, ModalWithNavComponent, {
        rootPage: HelpModalTouchComponent,
      });
    } else {
      this.modalService.setModalOptions(
        false,
        ModalWithNavComponent,
        {
          rootPage: HelpModalDesktopComponent,
        },
        'modal-desktop-size-xl',
      );
    }

    const modal = await this.modalController.create(
      this.modalService.modalOptions,
    );
    await modal.present();
  }

  async openAddToInventoryModal() {
    const selectedProductNumbers = this.selectedProducts.map(
      prod => prod.productNumber,
    );
    let inventoryId = this.inventoryService.exposedLastInventory;

    this.inventoryService
      .selectInventoryById$(inventoryId)
      .pipe(take(1))
      .subscribe(async inventory => {
        const ret = this.inventoryService.openAddToInventoryModal(
          selectedProductNumbers,
          this.platformService.isTouch.value,
          this.platformService.platformType,
          inventory,
          false,
        );
        (await ret).onDidDismiss().then(res => {
          if (res.data?.didSubmit) {
            this.clearSelectedProducts();
          }
        });
      });
  }

  calculateItemHeights() {
    const platform = this.platformService.getPlatformType();
    if (platform === PlatformEnum.desktop) {
      this.itemHeights = this.searchViewModel.listProducts.map(svm => {
        return calculateDesktopProductHeightForSearch(
          svm,
          !!this.powerReviewsMap?.get(svm.productNumber.toString()),
          this.isGuestUser,
        );
      });
    } else if (platform === PlatformEnum.tablet) {
      this.itemHeights = this.searchViewModel.listProducts.map(svm =>
        calculateTabletProductHeightForSearch(
          svm,
          !!this.powerReviewsMap?.get(svm.productNumber.toString()),
          this.isGuestUser,
        ),
      );
    } else if (platform === PlatformEnum.mobile) {
      this.itemHeights = this.searchViewModel.listProducts.map(svm =>
        calculateMobileProductHeightForSearch(
          svm,
          !!this.powerReviewsMap?.get(svm.productNumber.toString()),
          this.isGuestUser,
        ),
      );
    }

    if (
      this.itemHeights?.length > 0 &&
      this.itemHeights?.length < SEARCH_RECORD_PER_BATCH
    ) {
      this.itemHeights.push(SMALL_RESULT_COUNT_SPACER_HEIGHT);
    }
    this.searchViewModel.listProducts = [...this.searchViewModel.listProducts];
  }

  productNumbersConcat(
    searchViewModel: SearchViewModel,
    offset: number,
    records: number,
  ): string {
    let pageIds: number[] = [];
    const limit =
      offset + records > searchViewModel.listProducts.length
        ? searchViewModel.listProducts.length
        : offset + records;
    for (let i = offset; i < limit; i++) {
      pageIds.push(searchViewModel.listProducts[i].productNumber);
    }
    return pageIds.join(',');
  }

  get footerText(): string {
    if (
      this.productSelectionMode &&
      this.productSelectionMode === this.compareProductsSelection
    ) {
      return 'i18n.search.compare';
    } else {
      return this.modeConfig.footerText;
    }
  }

  updateTopSection(params: Params): void {
    this.isTopSection = false;
    if (!!params?.brandName) {
      const brandName = decodeURIComponent(params.brandName).toLowerCase();
      this.updateTopSectionByBrand(brandName);
    } else {
      this.updateTopSectionBySearchText(params?.searchText);
    }
  }

  updateTopSectionByBrand(brandName: string) {
    if (TOP_SECTION_BRANDS_LIST.includes(brandName)) {
      this.doUpdateTopSection(brandName);
    }
  }

  updateTopSectionBySearchText(searchText: string): void {
    if (TOP_SECTION_SEARCH_TEXT_LIST.includes(searchText)) {
      this.doUpdateTopSection(searchText);
    }
  }

  doUpdateTopSection(text: string): void {
    this.isTopSection = true;
    this.topSectionBackgroundImageStyle =
      TOP_SECTION_BACKGROUND_IMAGES_MAP.get(text);
    this.topSectionBackgroundPosition =
      TOP_SECTION_BACKGROUND_POSITION_MAP.get(text);
    this.topSectionImageTitle = this.translateService.instant(
      TOP_SECTION_IMAGE_TITLE_MAP.get(text),
    );
    this.topSectionTextTitle = this.translateService.instant(
      TOP_SECTION_TEXT_TITLE_MAP.get(text),
    );
    this.topSectionTextContent = this.translateService.instant(
      TOP_SECTION_TEXT_CONTENT_MAP.get(text),
    );
    this.isTopSectionTextExpanded =
      this.platformService.getPlatformType() !== PlatformEnum.mobile;
  }

  shouldDisplaySingleBanner(): boolean {
    return this.mode !== UsfProductCardModeEnum.exceptionSearch;
  }

  doUpdateTopSectionSingleBanner(
    banners: {
      bannerType: TopBannerType;
      desktopImage: string;
      tabletImage: string;
      mobileImage: string;
      bannerText?: string;
      styles?: any;
    }[],
  ) {
    this.topSectionSingleBanners = [];
    this.isTopSectionSingleBanner = true;

    banners.forEach((banner, i) => {
      let backgroundImage;
      switch (this.platformService.getPlatformType()) {
        case PlatformEnum.desktop:
          backgroundImage = banner.desktopImage;
          break;
        case PlatformEnum.tablet:
          backgroundImage = banner.tabletImage;
          break;
        case PlatformEnum.mobile:
          backgroundImage = banner.mobileImage;
          break;
      }
      this.topSectionSingleBanners.push({
        type: banner.bannerType,
        backgroundImage,
        bannerText: banner.bannerText,
        styles: banner.styles,
      });
    });
  }

  updateTopSectionSingleBanner(): void {
    if (this.shouldDisplaySingleBanner()) {
      combineLatest([
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_whilesupplieslast.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_serveyou.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_revman.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_payments.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_EBCOP.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_equip_and_supplies.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_global_search_banner_crossvalleyfarms.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_dynamic_EandS_promo_banner.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_dynamic_scoop_second_banner.name,
        ]),
        this.panAppState.feature$([
          FEATURES.split_dynamic_search_banner_summerstaples.name,
        ]),
        this.userService.hideInvoiceAndPayments$(),
      ]).subscribe(
        ([
          isWhileSuppliesEnabled,
          isServeYouEnabled,
          isRevmanEnabled,
          isPaymentsEnabled,
          isEbCopEnabled,
          isEquipmentAndSuppliesEnabled,
          isCrossValleyFarmsEnabled,
          isEquipmentAndSuppliesPromoEnabled,
          isScoopSecondaryBannerEnabled,
          ifSummerStaplesEnabled,
          hidePayments,
        ]) => {
          const searchText = this.searchText?.toLowerCase();
          this.isTopSectionSingleBanner = false;
          if (
            isWhileSuppliesEnabled &&
            TopSectionSingleBannerSearchText.WHILE_SUPPLIES_LAST.includes(
              searchText,
            )
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.WHILE_SUPPLIES_LAST,
                desktopImage:
                  '/assets/images/while-supplies-last-single-banner-desktop.webp',
                tabletImage:
                  '/assets/images/while-supplies-last-single-banner-tablet.webp',
                mobileImage:
                  '/assets/images/while-supplies-last-single-banner-mobile.webp',
              },
            ]);
          } else if (
            isServeYouEnabled &&
            TopSectionSingleBannerSearchText.SERVE_YOU.includes(searchText)
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.SERVE_YOU,
                desktopImage:
                  '/assets/images/serve-you-single-banner-desktop.webp',
                tabletImage:
                  '/assets/images/serve-you-single-banner-tablet.webp',
                mobileImage:
                  '/assets/images/serve-you-single-banner-mobile.webp',
              },
            ]);
          } else if (
            isRevmanEnabled &&
            TopSectionSingleBannerSearchText.REV_MAN_WINBACKS.includes(
              searchText,
            )
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.REV_MAN_WINBACKS,
                desktopImage:
                  '/assets/images/rev-man-winbacks-banner-desktop.webp',
                tabletImage:
                  '/assets/images/rev-man-winbacks-banner-tablet.webp',
                mobileImage:
                  '/assets/images/rev-man-winbacks-banner-mobile.webp',
              },
            ]);
          } else if (
            isPaymentsEnabled &&
            !hidePayments &&
            TopSectionSingleBannerSearchText.PAYMENTS.includes(searchText)
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.PAYMENTS,
                desktopImage: '/assets/images/payments-banner-desktop.webp',
                tabletImage: '/assets/images/payments-banner-tablet.webp',
                mobileImage: '/assets/images/payments-banner-mobile.webp',
              },
            ]);
          } else if (
            isEbCopEnabled &&
            TopSectionSingleBannerSearchText.EB_COP.includes(searchText)
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.EBCOP,
                desktopImage: '/assets/images/eb-cop-banner-desktop.webp',
                tabletImage: '/assets/images/eb-cop-banner-tablet.webp',
                mobileImage: '/assets/images/eb-cop-banner-mobile.webp',
              },
            ]);
          } else if (
            isEquipmentAndSuppliesEnabled &&
            TopSectionSingleBannerSearchText.EQUIPMENT_AND_SUPPLIES.includes(
              searchText,
            )
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.EQUIPMENT_AND_SUPPLIES,
                desktopImage:
                  '/assets/images/equipment-supplies-banner-desktop.webp',
                tabletImage:
                  '/assets/images/equipment-supplies-banner-tablet.webp',
                mobileImage:
                  '/assets/images/equipment-supplies-banner-mobile.webp',
              },
            ]);
          } else if (
            isEquipmentAndSuppliesPromoEnabled &&
            TopSectionSingleBannerSearchText.EQUIPMENT_AND_SUPPLIES_PROMO.includes(
              searchText,
            )
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.EQUIPMENT_AND_SUPPLIES_PROMO,
                desktopImage:
                  '/assets/images/equipment-and-supplies-promo-banner-desktop.webp',
                tabletImage:
                  '/assets/images/equipment-and-supplies-promo-banner-tablet.webp',
                mobileImage:
                  '/assets/images/equipment-and-supplies-promo-banner-mobile.webp',
              },
            ]);
          } else if (
            isCrossValleyFarmsEnabled &&
            TopSectionSingleBannerSearchText.CROSS_VALLEY_FARMS.includes(
              searchText,
            )
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.CROSS_VALLEY_FARMS,
                desktopImage:
                  '/assets/images/cross-valley-farms-banner-desktop.webp',
                tabletImage:
                  '/assets/images/cross-valley-farms-banner-tablet.webp',
                mobileImage:
                  '/assets/images/cross-valley-farms-banner-mobile.webp',
              },
            ]);
          } else if (
            TopSectionSingleBannerSearchText.ALLSCOOP.includes(this.searchText)
          ) {
            const scoopBanner = isScoopSecondaryBannerEnabled
              ? SCOOP_SINGLE_BANNER.secondaryBanner
              : SCOOP_SINGLE_BANNER.primaryBanner;
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.SCOOPPAGE,
                desktopImage: scoopBanner.desktopUrl,
                tabletImage: scoopBanner.tabletUrl,
                mobileImage: scoopBanner.mobileUrl,
              },
            ]);
          } else if (
            TopSectionSingleBannerSearchText.SCOOP.includes(searchText)
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.NEWSCOOP,
                desktopImage: '/assets/images/new-scoop-banner.webp',
                tabletImage: '/assets/images/new-scoop-banner.webp',
                mobileImage: '/assets/images/new-scoop-banner.webp',
                bannerText: 'New Scoop Products',
                styles: { width: '22rem', height: '6.5rem' },
              },
              {
                bannerType: TopBannerType.ALLSCOOP,
                desktopImage: '/assets/images/all-scoop-banner.webp',
                tabletImage: '/assets/images/all-scoop-banner.webp',
                mobileImage: '/assets/images/all-scoop-banner.webp',
                bannerText: 'All Scoop Products',
                styles: { width: '22rem', height: '6.5rem' },
              },
            ]);
          } else if (
            ifSummerStaplesEnabled &&
            TopSectionSingleBannerSearchText.SUMMER_STAPLES.includes(searchText)
          ) {
            this.doUpdateTopSectionSingleBanner([
              {
                bannerType: TopBannerType.SUMMER_STAPLES,
                desktopImage:
                  '/assets/images/summer-staples-banner-desktop.webp',
                tabletImage: '/assets/images/summer-staples-banner-tablet.webp',
                mobileImage: '/assets/images/summer-staples-banner-mobile.webp',
              },
            ]);
          }
        },
      );
    }
  }

  expandTopSectionText() {
    this.isTopSectionTextExpanded = !this.isTopSectionTextExpanded;
  }

  clickBannerAndNavigate(bannerPromoId: string, route: string) {
    this.searchService.trackSearchPageSingleBanner(bannerPromoId);
    this.router.navigate([route]);
  }

  clickBrandBannerAndNavigate(brandName: string) {
    this.searchService.trackSearchPageSingleBanner(brandName);
    this.navigationHelperService.routeToSearch({
      dimensionId: 0,
      pageType: 'all',
      brandName: encodeURIComponent(brandName),
    });
  }

  clickSearchBannerAndNavigate(searchText: string) {
    this.navigationHelperService.routeToSearch({
      searchText,
    });
  }

  onClickTopSectionSingleBanner(index) {
    switch (this.topSectionSingleBanners[index].type) {
      case TopBannerType.REV_MAN_WINBACKS:
        this.clickBannerAndNavigate('revman', PATHS.DEALS);
        break;
      case TopBannerType.PAYMENTS:
        this.clickBannerAndNavigate('payments', PATHS.PAYMENTS);
        break;
      case TopBannerType.CROSS_VALLEY_FARMS:
        this.clickBrandBannerAndNavigate('cross valley farms');
        break;
      case TopBannerType.SUMMER_STAPLES:
        this.clickSearchBannerAndNavigate('summerstaples');
        break;
      case TopBannerType.NEWSCOOP:
        this.searchService.trackSearchPageSingleBanner(this.newScoopProducts);
        this.clickSearchBannerAndNavigate(this.newScoopProducts);
        break;
      case TopBannerType.ALLSCOOP:
        this.searchService.trackSearchPageSingleBanner(
          TopSectionSearchText.ALLSCOOP,
        );
        this.clickSearchBannerAndNavigate(TopSectionSearchText.ALLSCOOP);
        break;
      case TopBannerType.EQUIPMENT_AND_SUPPLIES_PROMO:
        this.searchService.trackSearchPageSingleBanner(
          'equipment and supplies q1 promotion',
        );
        this.clickSearchBannerAndNavigate(
          TopSectionSearchText.EQUIPMENT_AND_SUPPLIES_PROMO,
        );
        break;
      default:
        let searchText = '';
        const searchTextQueryParam = this.searchText?.toLowerCase();

        if (
          TopSectionSingleBannerSearchText.WHILE_SUPPLIES_LAST.includes(
            searchTextQueryParam,
          )
        ) {
          searchText = TopSectionSearchText.WHILE_SUPPLIES_LAST;
          this.searchService.trackSearchPageSingleBanner('while supplies last');
        } else if (
          TopSectionSingleBannerSearchText.SERVE_YOU.includes(
            searchTextQueryParam,
          )
        ) {
          searchText = TopSectionSearchText.SERVE_YOU;
          this.searchService.trackSearchPageSingleBanner('serveyou');
        } else if (
          TopSectionSingleBannerSearchText.EB_COP.includes(searchTextQueryParam)
        ) {
          searchText = TopSectionSearchText.EBCOP;
          this.searchService.trackSearchPageSingleBanner('ebcop');
        } else if (
          TopSectionSingleBannerSearchText.EQUIPMENT_AND_SUPPLIES.includes(
            searchTextQueryParam,
          )
        ) {
          searchText = TopSectionSearchText.EQUIPMENT_AND_SUPPLIES;
          this.searchService.trackSearchPageSingleBanner(
            'equipment and supplies',
          );
        } else if (
          TopSectionSingleBannerSearchText.ALLSCOOP.includes(
            searchTextQueryParam,
          )
        ) {
          searchText = TopSectionSearchText.SCOOPBANNER;
          this.searchService.trackSearchPageSingleBanner('scoop');
        }
        this.clickSearchBannerAndNavigate(searchText);
    }
  }

  trackPageLoad(data: SearchViewModel) {
    if (!this.isTrackingData && !!data) {
      const ancestorLabel: string =
        data?.searchResponse?.breadCrumbs?.selectedFilters['0']?.ancestors['0']
          ?.label ?? '';
      const label: string =
        data?.searchResponse?.breadCrumbs?.selectedFilters['0']?.label ?? '';
      const searchTerms: string =
        data?.searchResponse?.breadCrumbs?.searchCrumbs['0']?.terms ?? '';
      const searchFilterProperties: string =
        data?.searchRequest?.searchFilterProperties ?? '';
      if (
        !this.searchViewModel?.isLoadingMore &&
        (this.originSearchPage === SEARCH_PAGES_ENUM.catalog ||
          (this.originSearchPage === SEARCH_PAGES_ENUM.search &&
            (searchTerms || searchFilterProperties)) ||
          (this.originSearchPage === SEARCH_PAGES_ENUM.typeAhead && label))
      ) {
        const list = data?.searchResponse?.richTextMainList;
        const bannerImageIds: string = !!list
          ? list[0].banners
              ?.map(banner => getImageIdFromUrl(banner?.imageURL))
              .join(',')
          : '';

        let search_type = SEARCH_TYPE.catalogSearch;
        if (this.mode === UsfProductCardModeEnum.replacementSearch) {
          search_type = SEARCH_TYPE.searchForSubs;
        } else if (this.searchViewModel?.searchRequest?.didYouMean) {
          const isBrand =
            data?.searchResponse?.breadCrumbs?.selectedFilters['0']?.displayName
              ?.toLowerCase()
              .indexOf('brand') > -1;
          search_type =
            this.originSearchPage === SEARCH_PAGES_ENUM.search || !!isBrand
              ? SEARCH_TYPE.searchWithinSearch
              : SEARCH_TYPE.catalogSearchWithin;
        } else if (this.originSearchPage === SEARCH_PAGES_ENUM.typeAhead) {
          search_type = SEARCH_TYPE.typeAhead;
        }

        if (
          this.originSearchPage === SEARCH_PAGES_ENUM.catalog &&
          ancestorLabel !== '' &&
          label !== ''
        ) {
          // Creating a string representation of filters
          let temp_filters = {};
          for (const selectedFilter of data?.searchResponse?.breadCrumbs
            ?.selectedFilters) {
            if (temp_filters.hasOwnProperty(selectedFilter.displayName)) {
              temp_filters[selectedFilter.displayName] =
                temp_filters[selectedFilter.displayName] +
                ',' +
                selectedFilter.label;
            } else {
              temp_filters[selectedFilter.displayName] = selectedFilter.label;
            }
          }

          let temp_str = '';
          for (const [key, value] of Object.entries(temp_filters)) {
            temp_str = temp_str + key + '=' + value + '';
          }

          this.searchService.trackCatalogSubcategoryPageLoad(temp_str);
        } else {
          // Creating a string representation of filters
          let temp_filters = {};
          for (const selectedFilter of data?.searchResponse?.breadCrumbs
            ?.selectedFilters) {
            if (temp_filters.hasOwnProperty(selectedFilter.displayName)) {
              temp_filters[selectedFilter.displayName] =
                temp_filters[selectedFilter.displayName] +
                ',' +
                selectedFilter.label;
            } else {
              temp_filters[selectedFilter.displayName] = selectedFilter.label;
            }
          }

          const entriesFilter = Object.entries(temp_filters);
          const temp_str = entriesFilter.reduce(
            (acc, [key, value], index) =>
              `${acc}${key}=${value}${
                index + 1 === entriesFilter.length ? '' : ';'
              }`,
            '',
          );
          const initialRecords = data?.listProducts?.slice(
            0,
            SEARCH_RECORD_PER_BATCH,
          );
          const productNumbers = [];

          const exceptionProducts =
            this.searchAnalyticsService.buildExceptionTrackingProducts(
              initialRecords,
            );

          initialRecords?.forEach(value => {
            const exceptionProduct = exceptionProducts.find(
              p =>
                p.divisionApn ===
                value?.summary?.divisionNumber + '-' + value?.productNumber,
            );
            if (!exceptionProduct) {
              productNumbers.push({
                divisionApn:
                  value?.summary?.divisionNumber + '-' + value?.productNumber,
                attributes: value?.trackingAttributes,
              });
            }
          });
          this.searchService.trackSearchResultPageLoad(
            bannerImageIds,
            temp_str,
            search_type,
            [...exceptionProducts, ...productNumbers],
            data?.searchRequest?.searchText,
          );
        }
      }
      this.isTrackingData = true;
    }
  }

  setPowerReviews() {
    this.pwrRatingStarsMap
      .pipe(
        filter(val => Array.from(val.values()).some(v => !!v)),
        take(1),
      )
      .subscribe(ratings => {
        this.powerReviewsMap = ratings;
        if (!!ratings && ratings.size > 0) {
          this.calculateItemHeights();
        }
      });
  }

  downloadSearchResults() {
    const request = this.searchViewModel.searchRequest;
    const ERROR_MSJ =
      'There was an issue downloading your list. Please try again.';
    if (this.searchViewModel.searchResponse.totalNumberOfRecords > 3000) {
      this.searchService.displayDownloadLimitMessage(
        'Report limited to 3,000 lines. Please reduce search results and try again.',
      );
    } else {
      let timeoutHandle: any = setTimeout(() => {
        this.isDownloading = true;
      }, 500);

      this.searchService
        .downloadSearchResults(request)
        .pipe(withLatestFrom(this.userCustomer$))
        .subscribe({
          next: values => {
            if (values[0].status === 200) {
              this.downLoadFile(
                values[0],
                values[1] as UserCustomerInfo,
                timeoutHandle,
              );
            } else {
              this.isDownloading = false;
              clearTimeout(timeoutHandle);
              this.searchService.displayDownloadLimitMessage(ERROR_MSJ);
            }
          },
          error: e => {
            this.isDownloading = false;
            clearTimeout(timeoutHandle);
            this.searchService.displayDownloadLimitMessage(ERROR_MSJ);
          },
        });
    }
  }

  downLoadFile(
    response: HttpResponse<any>,
    userCustomer: UserCustomerInfo,
    timeoutHandle: Timer,
  ) {
    const searchText = this.searchText ? this.searchText : 'shop';
    const currentDate = this.fileHandlerBaseService.datePipe.transform(
      Date.now(),
      'MMddYYYY',
    );
    const fileName =
      'SearchResults_cust' +
      userCustomer?.selectedCustomer?.customerNumber +
      '_' +
      currentDate +
      '_' +
      searchText +
      '.xlsx';

    this.fileHandlerBaseService.downloadFile(
      response?.body,
      fileName,
      'XLSX',
      true,
      false,
    );
    this.isDownloading = false;
    clearTimeout(timeoutHandle);
  }

  async openMobileActionSheet() {
    const buttons = [];
    buttons.push({
      text: this.translateService.instant('i18n.common.cancel'),
      role: 'cancel',
      cssClass: 'cancel-button',
    });

    buttons.push({
      text: this.translateService.instant('i18n.common.download'),
      handler: () => {
        this.downloadSearchResults();
      },
    });
    const actionSheet = await this.actionSheetController.create({
      mode: 'ios',
      buttons,
      cssClass: 'action-sheet-touch',
    });
    await actionSheet.present();
  }
}
